<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!-- <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item> -->

      <!-- <el-form-item label="截单时间" prop="cut_time">
            <el-time-picker
              v-model="form.cut_time"
              start-placeholder="时间"
              placeholder="选择时间"
              format="HH:mm"
              value-format="HH:mm"
              >
            </el-time-picker>
          </el-form-item>  

      <el-form-item label="批发点固定配送费/元" prop="cost_gk" label-width="150px">
        <el-input v-model="form.cost_gk" class="max-w460" placeholder="请输入配送点固定配送费/元"></el-input>
      </el-form-item>

      <el-form-item label="配送每公里/元" prop="cost_k" label-width="150px">
        <el-input v-model="form.cost_k" class="max-w460"  placeholder="请输入配送每公里/元"></el-input>
      </el-form-item>

               
      <el-form-item label="起送订单金额/元" prop="minimumOrderAmount" label-width="150px">
            <el-input v-model="form.minimumOrderAmount" placeholder="请输入起送订单金额/元" class="max-w460"></el-input>
          </el-form-item>  


      <el-form-item label="首单免配送费金额/元" prop="first_order_delivery_price_free" label-width="150px">
            <el-input v-model="form.first_order_delivery_price_free" placeholder="请输入首单免配送费金额/元" class="max-w460"></el-input>
     </el-form-item>

   

      <el-form-item label="非首单免配送费金额/元" prop="other_order_delivery_price_free" label-width="150px">
            <el-input v-model="form.other_order_delivery_price_free" placeholder="请输入非首单免配送费金额/元" class="max-w460"></el-input>
          </el-form-item>

    

          
          <el-form-item label="司机每单/元" prop="driver_order" label-width="150px">
            <el-input v-model="form.driver_order" placeholder="请输入司机每单/元" class="max-w460"></el-input>
          </el-form-item>  


        -->

        <el-form-item label="司机完单方式" prop="open_hx_type">
              <el-radio-group v-model="form.open_hx_type">
                <el-radio :label="10">门店扫码核销完成</el-radio>
                <el-radio :label="20">提交送货凭证，自动配送完成</el-radio>
              </el-radio-group>
        </el-form-item>

        <el-form-item label="多少分钟后自动完成送货" v-if="form.open_hx_type == 20" prop="driver_order" label-width="150px">
            <el-input v-model="form.hx_minute" placeholder="请输入多少分钟后自动完成送货" class="max-w460"></el-input>分钟
          <div>输入0自动完成</div>
        </el-form-item> 
 
          
    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import LineApi from '@/api/line.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
        cost_gk:0,
        cost_k:0,
        first_order_delivery_price_free:0,
        first_order_delivery_price_no:0,
        other_order_delivery_price_free:0,
        other_order_delivery_price_no:0,
        cut_time:"",
        driver_order_price:0,
        minimumOrderAmount:0,

        hx_minute:0,
        open_hx_type:20,
      },
      setting: [],
      loading: false,
      isProductUpload:false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      LineApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      LineApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/line/setting/getSetting.vue